import React from "react";
import {
    Card,
    Row,
    Col,
    List,
    Statistic,
    Switch,
    Button,
    Divider,
    Tabs
} from "antd";
import {PoweroffOutlined} from "@ant-design/icons";
import ServerOverview from "../../../components/Server/ServerOverView";
import styles from "./ServerDetails.module.css";
import Backups from "../../../components/Server/Backups";
import Graphs from "../../../components/Server/Graphs";
import Snapshots from "../../../components/Server/Snapshots";
import LoadBalancers from "../../../components/Server/LoadBalancers";
import Networking from "../../../components/Server/Networking";
import Firewalls from "../../../components/Server/Firewalls";
import Volumes from "../../../components/Server/Volumes";
import Power from "../../../components/Server/Power";
import Rescue from "../../../components/Server/Rescue";
import ISOImages from "../../../components/Server/ISOImages";
import Rescale from "../../../components/Server/Rescale";
import Rebuild from "../../../components/Server/Rebuild";
import Delete from "../../../components/Server/Delete";

const ServerDetails = () => {
    const onChange = key => {
        console.log(key);
    };
    const items = [
        {
            key: '1',
            label: 'Overview',
            children: <ServerOverview/>
        }, {
            key: "graphs",
            label: "Graphs",
            children: <Graphs/>
        }, {
            key: "backups",
            label: "Backups",
             children: <Backups/>
        }, {
            key: "snapshots",
            label: "Snapshots",
             children: <Snapshots/>
        }, {
            key: "load_balancers",
            label: "Load Balancers",
             children: <LoadBalancers/>
        }, {
            key: "networking",
            label: "Networking",
            children: <Networking/>
        }, {
            key: "firewalls",
            label: "Firewalls",
            children: <Firewalls/>
        }, {
            key: "volumes",
            label: "Volumes",
            children: <Volumes/>
        }, {
            key: "power",
            label: "Power",
            children: <Power/>
        }, {
            key: "rescue",
            label: "Rescue",
            children: <Rescue/>
        }, {
            key: "iso_images",
            label: "ISO Images",
            children: <ISOImages/>
        }, {
            key: "rescale",
            label: "Rescale",
            children: <Rescale/>
        }, {
            key: "rebuild",
            label: "Rebuild",
            children: <Rebuild/>
        }, {
            key: "delete",
            label: "Delete",
            children: <Delete/>
        }
    ];
    const activities = ["Server console requested", "Server started", "Server created", "Backups enabled", "Primary IP created"];

    return (
        <div
            style={{
            padding: 24,
            minHeight: "100vh",
            color: "#fff"
        }}>
            {/* Header */}
            <Row
                justify="space-between"
                align="middle"
                style={{
                marginBottom: 24
            }}>
                <Col>
                    <h2 className={styles.primary}>CX33</h2>
                    <p className={styles.primary}>ubuntu-8gb-nbg1-1</p>
                    <p className={styles.primary}>142.132.169.253 • 2a01:4f8:1c1b:55a2::/64</p>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        className={styles.primaryBackground}
                        icon={< PoweroffOutlined />}>Actions</Button>
                    <Switch
                        defaultChecked
                        style={{
                        marginLeft: 12
                    }}/>
                </Col>
            </Row>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange}/>

        </div>
    );
};

export default ServerDetails;
